import * as Yup from 'yup'

const validationSchema = Yup.object().shape({
  name: Yup.string().required().label('Name')
})

export default validationSchema
